var Backbone, EmailFormTextInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

EmailFormTextInputView = (function(superClass) {
  extend(EmailFormTextInputView, superClass);

  function EmailFormTextInputView() {
    return EmailFormTextInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormTextInputView.prototype.initialize = function(options) {
    var ref, ref1;
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.isInputFieldEmpty = true;
    this.maxLength = 250;
    this.model = this.options.model;
    this.isFlexibleStepThree = this.options.isFlexibleStepThree;
    this.label = this.model.label;
    this.value = this.model.value;
    this.base_template = this.options.template;
    this.isInputCompulsory = this.model.required === true || this.model.required === "true";
    if (((ref = this.options.model.additional_attributes) != null ? (ref1 = ref.maximum_number_of_characters_or_digits) != null ? ref1.length : void 0 : void 0) > 0) {
      return this.maxLength = parseInt(this.options.model.additional_attributes.maximum_number_of_characters_or_digits);
    }
  };

  EmailFormTextInputView.prototype.render = function() {
    return this.$el.html(toHtml(this.base_template, this.toHash()));
  };

  EmailFormTextInputView.prototype.toHash = function() {
    var hash;
    hash = {
      stepThreeType: this.isFlexibleStepThree ? 'flexibleStepThree' : 'defaultStepThree',
      label: this.label,
      required: this.isInputCompulsory,
      maxLength: this.maxLength,
      counter: this.model.counter,
      isLoggedIn: window.isLoggedIn,
      value: this.value
    };
    return _.extend(this.template, hash);
  };

  EmailFormTextInputView.prototype.getInputHtmlElement = function() {
    return this.$el.find(this.elementID);
  };

  EmailFormTextInputView.prototype.isInputGiven = function() {
    var ref, ref1, ref2;
    return ((ref = this.getInputHtmlElement()) != null ? (ref1 = ref.val()) != null ? (ref2 = ref1.trim()) != null ? ref2.length : void 0 : void 0 : void 0) > 0;
  };

  EmailFormTextInputView.prototype.readInput = function() {
    var ref, ref1;
    return (ref = this.getInputHtmlElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim() : void 0 : void 0;
  };

  EmailFormTextInputView.prototype.isInputValid = function() {
    return true;
  };

  EmailFormTextInputView.prototype.validateEmailForm = function() {
    if (this.isInputCompulsory && ((this.isInputFieldEmpty && this.isInputGiven()) || !(this.isInputFieldEmpty || this.isInputGiven()))) {
      this.isInputFieldEmpty = !this.isInputGiven();
      return this.options.validateEmailForm();
    }
  };

  EmailFormTextInputView.prototype.populateInput = function(data) {
    var inputData;
    if (this.isInputGiven()) {
      inputData = this.readInput();
      return data.description += "\n\n " + this.label + " : " + inputData;
    }
  };

  return EmailFormTextInputView;

})(Backbone.View);

module.exports = EmailFormTextInputView;

//# sourceMappingURL=data:application/json;base64,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
